import { useCallback, useSyncExternalStore } from 'react';

const KEY = 'vot_recently_viewed';
const MAX = 8;

/**
 * Last-N просмотренных блюд. Обновляется при открытии DishDetailModal,
 * читается каруселью RecentlyViewed — это разные компоненты, поэтому
 * store модульный (useSyncExternalStore): visit() в модалке должен сразу
 * отразиться в карусели. `storage`-событие покрывает только другие вкладки.
 */
function readStorage(): number[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr.filter((n) => typeof n === 'number').slice(0, MAX) : [];
  } catch {
    return [];
  }
}

let current: number[] = readStorage();
const listeners = new Set<() => void>();

function emit(): void {
  listeners.forEach((l) => l());
}

function subscribe(cb: () => void): () => void {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

function getSnapshot(): number[] {
  return current;
}

if (typeof window !== 'undefined') {
  window.addEventListener('storage', (e: StorageEvent) => {
    if (e.key === KEY) {
      current = readStorage();
      emit();
    }
  });
}

function visitDish(id: number): void {
  const next = [id, ...current.filter((x) => x !== id)].slice(0, MAX);
  current = next;
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {}
  emit();
}

export function useRecentlyViewed() {
  const ids = useSyncExternalStore(subscribe, getSnapshot);
  const visit = useCallback((id: number) => visitDish(id), []);
  return { ids, visit };
}
